import Vue from 'vue';
import axios from 'axios';
import { login as javaLogin, logout as javaLogout } from './javaAuth';

const {
    javaUrl,
} = require('../package.json');

const service = axios.create({
    baseURL: javaUrl,
    headers: {
        'Content-Type': 'application/json; charset=UTF-8',
    },
    data: {},
    // withCredentials: true, // send cookies when cross-domain requests
    timeout: 10000, // request timeout
});

// http请求拦截器
service.interceptors.request.use(
    (config) => {
        config.withCredentials = true; // 允许跨域cookie
        const token = localStorage.getItem('java_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (err) => Promise.reject(err)
);

let isRefreshing = false;
let refreshSubscribers = [];

function onTokenRefreshed(token) {
    refreshSubscribers.forEach((cb) => cb(token));
    refreshSubscribers = [];
}

function addRefreshSubscriber(cb) {
    refreshSubscribers.push(cb);
}

// http响应拦截器
service.interceptors.response.use(
    (response) => {
        if (response.data instanceof Object) {
            if (response.data && response.data.redirect) {
                window.location.replace(response.data.redirect);
            }
            // 业务 code 为 401 且不是登录接口本身时，自动重新登录并重试
            if (response.data && response.data.code === 401) {
                const config = response.config;
                const url = config ? config.url : '';
                if (url && url.indexOf('/login') === -1) {
                    if (!isRefreshing) {
                        isRefreshing = true;
                        javaLogin().then((token) => {
                            isRefreshing = false;
                            onTokenRefreshed(token);
                        }).catch(() => {
                            isRefreshing = false;
                            refreshSubscribers = [];
                            javaLogout();
                        });
                    }
                    return new Promise((resolve) => {
                        addRefreshSubscriber((token) => {
                            config.headers.Authorization = `Bearer ${token}`;
                            resolve(service(config));
                        });
                    });
                }
            }
            if (response.data && 'status' in response.data && !response.data.status) {
                Vue.prototype.$message.error(response.data.msg || '网络请求异常');
                return Promise.reject(response);
            }
        }
        return response;
    },
    (err) => Promise.reject(err)
);

Vue.prototype.$jHttp = service;